export enum SecondaryNavigationVariation {
  Scrollable = 'scrollable',
  PayoutLogicSubTabs = 'payout-logic-sub-tabs',
}

export enum SecondaryNavigationItemVariation {
  NoTrim = 'no-trim',
}
